// Live viewport canvas aspect ratio.
//
// ViewportV2 publishes the canvas size's aspect (width / height) here on
// every R3F size change. PositionPad3D subscribes so it can mirror the
// runtime camera's effective horizontal frustum — the camera uses
// `setViewOffset` to render the wider canvas around the export-aspect rect,
// so what the user actually sees on screen is bounded by canvas aspect,
// not export aspect.

import {useSyncExternalStore} from 'react'

let aspect = 1
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const notify = () => {
  listeners.forEach((l) => l())
}

export const setViewportAspect = (value: number) => {
  if (!Number.isFinite(value) || value <= 0) return
  if (Math.abs(aspect - value) < 1e-4) return
  aspect = value
  notify()
}

export const getViewportAspect = (): number => aspect

export const useViewportAspect = (): number => useSyncExternalStore(subscribe, getViewportAspect, getViewportAspect)
